module.exports = __webpack_public_path__ + "img/content-block-sm-user-guide_2x.0bba0962.png";